import * as React from "react";
const SvgCloseCircle20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 9a7 7 0 1 1 14 0A7 7 0 0 1 2 9Zm7-9a9 9 0 1 0 0 18A9 9 0 0 0 9 0ZM7.207 5.793 6.5 5.086 5.086 6.5l.707.707L7.586 9l-1.793 1.793-.707.707L6.5 12.914l.707-.707L9 10.414l1.793 1.793.707.707 1.414-1.414-.707-.707L10.414 9l1.793-1.793.707-.707L11.5 5.086l-.707.707L9 7.586 7.207 5.793Z",
      clipRule: "evenodd"
    })
  );
export default SvgCloseCircle20Px;
